/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './badge-module';
export * from './badge';



// WEBPACK FOOTER //
// ../../../../../src/material/badge/public-api.ts